import type { AxiosInstance } from 'axios';
import type {
  AnnouncementDetail,
  AnnouncementHeartBatchResult,
  AnnouncementHeartCount,
  ApplyAnnouncementHeartBatchRequest,
  GetAnnouncementListRequest,
  GetAnnouncementListResponse,
} from './types';

const DEFAULT_OFFSET = 0;
const ALL_DATA_LIMIT = -1;

export const getAnnouncementList = async (
  instance: AxiosInstance,
  params?: GetAnnouncementListRequest,
  signal?: AbortSignal,
): Promise<GetAnnouncementListResponse> => {
  return await instance.get<unknown, GetAnnouncementListResponse>(
    '/v1/announcement/announcements',
    {
      params: {
        offset: params?.offset ?? DEFAULT_OFFSET,
        limit: params?.limit ?? ALL_DATA_LIMIT,
      },
      signal,
    },
  );
};

export const getAnnouncementDetail = async (
  instance: AxiosInstance,
  announcementId: string,
  signal?: AbortSignal,
): Promise<AnnouncementDetail> => {
  return await instance.get<unknown, AnnouncementDetail>(
    `/v1/announcement/announcements/${announcementId}`,
    { signal },
  );
};

export const getAnnouncementHeartCount = async (
  instance: AxiosInstance,
  announcementId: string,
  signal?: AbortSignal,
): Promise<AnnouncementHeartCount> => {
  return await instance.get<unknown, AnnouncementHeartCount>(
    `/v1/announcement/announcements/${announcementId}/hearts`,
    { signal },
  );
};

export const applyAnnouncementHeartBatch = async (
  instance: AxiosInstance,
  announcementId: string,
  body: ApplyAnnouncementHeartBatchRequest,
): Promise<AnnouncementHeartBatchResult> => {
  return await instance.post<unknown, AnnouncementHeartBatchResult>(
    `/v1/announcement/announcements/${announcementId}/hearts`,
    body,
  );
};
